module.exports = __webpack_public_path__ + "media/images/admin/icons/phone-22904118b466d50710a6927da97da9cf.svg";